var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/human-format/index.js
var require_human_format = __commonJS({
  "../../node_modules/human-format/index.js"(exports, module) {
    "use strict";
    (function(root, factory) {
      if (typeof define === "function" && define.amd) {
        define([], factory);
      } else if (typeof exports === "object") {
        module.exports = factory();
      } else {
        root.humanFormat = factory();
      }
    })(exports, function() {
      "use strict";
      function assign(dst, src) {
        var i, n, prop;
        for (i = 1, n = arguments.length; i < n; ++i) {
          src = arguments[i];
          if (src != null) {
            for (prop in src) {
              if (has(src, prop)) {
                dst[prop] = src[prop];
              }
            }
          }
        }
        return dst;
      }
      function compareLongestFirst(a, b) {
        return b.length - a.length;
      }
      function compareSmallestFactorFirst(a, b) {
        return a.factor - b.factor;
      }
      function escapeRegexp(str) {
        return str.replace(/([.*+?=^!:${}()|[\]/\\])/g, "\\$1");
      }
      function forEach(arr, iterator) {
        var i, n;
        for (i = 0, n = arr.length; i < n; ++i) {
          iterator(arr[i], i);
        }
      }
      function forOwn(obj, iterator) {
        var prop;
        for (prop in obj) {
          if (has(obj, prop)) {
            iterator(obj[prop], prop);
          }
        }
      }
      var has = /* @__PURE__ */ function(hasOwnProperty) {
        return function has2(obj, prop) {
          return obj != null && hasOwnProperty.call(obj, prop);
        };
      }(Object.prototype.hasOwnProperty);
      function resolve(container, entry) {
        while (typeof entry === "string") {
          entry = container[entry];
        }
        return entry;
      }
      function Scale(prefixes) {
        this._prefixes = prefixes;
        var escapedPrefixes = [];
        var list = [];
        forOwn(prefixes, function(factor, prefix) {
          escapedPrefixes.push(escapeRegexp(prefix));
          list.push({
            factor,
            prefix
          });
        });
        var lcPrefixes = this._lcPrefixes = {};
        forOwn(prefixes, function(factor, prefix) {
          var lcPrefix = prefix.toLowerCase();
          if (!has(prefixes, lcPrefix)) {
            lcPrefixes[lcPrefix] = prefix;
          }
        });
        list.sort(compareSmallestFactorFirst);
        this._list = list;
        escapedPrefixes.sort(compareLongestFirst);
        this._regexp = new RegExp(
          "^\\s*(-)?\\s*(\\d+(?:\\.\\d+)?)\\s*(" + escapedPrefixes.join("|") + ")\\s*(.*)\\s*?$",
          "i"
        );
      }
      Scale.create = function Scale$create(prefixesList, base2, initExp) {
        var prefixes = {};
        if (initExp === void 0) {
          initExp = 0;
        }
        forEach(prefixesList, function(prefix, i) {
          prefixes[prefix] = Math.pow(base2, i + initExp);
        });
        return new Scale(prefixes);
      };
      Scale.prototype.findPrefix = function Scale$findPrefix(value) {
        var list = this._list;
        var low = 0;
        var high = list.length - 1;
        var mid, current;
        while (low !== high) {
          mid = low + high + 1 >> 1;
          current = list[mid].factor;
          if (current > value) {
            high = mid - 1;
          } else {
            low = mid;
          }
        }
        return list[low];
      };
      Scale.prototype.parse = function Scale$parse(str, strict) {
        var matches = str.match(this._regexp);
        if (matches === null) {
          return;
        }
        var prefix = matches[3];
        var factor;
        if (has(this._prefixes, prefix)) {
          factor = this._prefixes[prefix];
        } else if (!strict && (prefix = prefix.toLowerCase(), has(this._lcPrefixes, prefix))) {
          prefix = this._lcPrefixes[prefix];
          factor = this._prefixes[prefix];
        } else {
          return;
        }
        var value = +matches[2];
        if (matches[1] !== void 0) {
          value = -value;
        }
        return {
          factor,
          prefix,
          unit: matches[4],
          value
        };
      };
      var scales = {
        // https://en.wikipedia.org/wiki/Binary_prefix
        binary: Scale.create(",Ki,Mi,Gi,Ti,Pi,Ei,Zi,Yi".split(","), 1024),
        // https://en.wikipedia.org/wiki/Metric_prefix
        //
        // Not all prefixes are present, only those which are multiple of
        // 1000, because humans usually prefer to see close numbers using
        // the same unit to ease the comparison.
        SI: Scale.create("y,z,a,f,p,n,\xB5,m,,k,M,G,T,P,E,Z,Y".split(","), 1e3, -8)
      };
      var defaults = {
        // Decimal digits for formatting.
        maxDecimals: 2,
        // separator to use between value and units
        separator: " ",
        // Unit to use for formatting.
        unit: ""
      };
      var rawDefaults = {
        scale: "SI",
        // Strict mode prevents parsing of incorrectly cased prefixes.
        strict: false
      };
      function humanFormat2(value, opts) {
        opts = assign({}, defaults, opts);
        var decimals = opts.decimals;
        if (decimals !== void 0) {
          delete opts.maxDecimals;
        }
        var info = humanFormat$raw(value, opts);
        value = decimals !== void 0 ? info.value.toFixed(decimals) : String(info.value);
        var suffix = info.prefix + opts.unit;
        return suffix === "" ? value : value + opts.separator + suffix;
      }
      var humanFormat$bytes$opts = { scale: "binary", unit: "B" };
      function humanFormat$bytes(value, opts) {
        return humanFormat2(
          value,
          opts === void 0 ? humanFormat$bytes$opts : assign({}, humanFormat$bytes$opts, opts)
        );
      }
      function humanFormat$parse(str, opts) {
        var info = humanFormat$parse$raw(str, opts);
        return info.value * info.factor;
      }
      function humanFormat$parse$raw(str, opts) {
        if (typeof str !== "string") {
          throw new TypeError("str must be a string");
        }
        opts = assign({}, rawDefaults, opts);
        var scale = resolve(scales, opts.scale);
        if (scale === void 0) {
          throw new Error("missing scale");
        }
        var info = scale.parse(str, opts.strict);
        if (info === void 0) {
          throw new Error("cannot parse str");
        }
        return info;
      }
      function humanFormat$raw(value, opts) {
        if (value === 0) {
          return {
            value: 0,
            prefix: ""
          };
        } else if (value < 0) {
          var result = humanFormat$raw(-value, opts);
          result.value = -result.value;
          return result;
        }
        if (typeof value !== "number" || Number.isNaN(value)) {
          throw new TypeError("value must be a number");
        }
        opts = assign({}, rawDefaults, opts);
        var scale = resolve(scales, opts.scale);
        if (scale === void 0) {
          throw new Error("missing scale");
        }
        var power;
        var maxDecimals = opts.maxDecimals;
        var autoMaxDecimals = maxDecimals === "auto";
        if (autoMaxDecimals) {
          power = 10;
        } else if (maxDecimals !== void 0) {
          power = Math.pow(10, maxDecimals);
        }
        var prefix = opts.prefix;
        var factor;
        if (prefix !== void 0) {
          if (!has(scale._prefixes, prefix)) {
            throw new Error("invalid prefix");
          }
          factor = scale._prefixes[prefix];
        } else {
          var _ref = scale.findPrefix(value);
          if (power !== void 0) {
            do {
              factor = _ref.factor;
              var r = factor / power;
              value = Math.round(value / r) * r;
            } while ((_ref = scale.findPrefix(value)).factor !== factor);
          } else {
            factor = _ref.factor;
          }
          prefix = _ref.prefix;
        }
        value = power === void 0 ? value / factor : Math.round(value * power / factor) / power;
        if (autoMaxDecimals && Math.abs(value) >= 10) {
          value = Math.round(value);
        }
        return {
          prefix,
          value
        };
      }
      humanFormat2.bytes = humanFormat$bytes;
      humanFormat2.parse = humanFormat$parse;
      humanFormat$parse.raw = humanFormat$parse$raw;
      humanFormat2.raw = humanFormat$raw;
      humanFormat2.Scale = Scale;
      return humanFormat2;
    });
  }
});

// src/hyperevm.ts
import { defineChain } from "viem";
var hyperevm = defineChain({
  id: 999,
  name: "HyperEVM",
  network: "HyperEVM",
  nativeCurrency: { name: "HYPE", symbol: "HYPE", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.hyperliquid.xyz/evm"]
    },
    public: {
      http: ["https://rpc.hyperliquid.xyz/evm"]
    }
  },
  blockExplorers: {
    default: {
      name: "Purrsec",
      url: "https://hyperevmscan.io/",
      apiUrl: ""
    }
  },
  contracts: {
    multicall3: {
      address: "0x76Ab12e29598D719C32E02CEf502c33a115B73ec",
      blockCreated: 11090
    }
  }
});

// src/format.ts
var import_human_format = __toESM(require_human_format());
import numeral from "numeral";
function ellipseAddress(address, width = 6) {
  if (!address) {
    return "";
  }
  if (width === -1) {
    return address;
  }
  return `${address.slice(0, width)}...${address.slice(-width)}`;
}
function formatPrice(price) {
  if (!price) return "0.00";
  const p = Number(price);
  if (p >= 1e4) {
    return numeral(p).format("0,0");
  }
  if (p >= 1) {
    return numeral(p).format("0,0.00");
  }
  if (p >= 0.1) {
    return numeral(p).format("0,0.0000");
  }
  if (p >= 0.01) {
    return numeral(p).format("0,0.00000");
  }
  if (p >= 1e-3) {
    return numeral(p).format("0,0.000000");
  }
  return formatPriceSubscript(price, 6);
}
var formatPriceSubscript = (num, maxDecimals = 6) => {
  const str = typeof num === "number" ? num.toString() : num;
  if (!str.includes(".")) return str;
  const match = str.match(/\.?(0+)([1-9].*)/);
  if (!match || match.length <= 1) return str;
  const zeroCount = match[1]?.length ?? 0;
  const rest = match[2]?.slice(0, maxDecimals);
  return `0.0${subscript(zeroCount)}${rest}`;
};
var subscript = (num) => {
  const map = {
    "0": "\u2080",
    "1": "\u2081",
    "2": "\u2082",
    "3": "\u2083",
    "4": "\u2084",
    "5": "\u2085",
    "6": "\u2086",
    "7": "\u2087",
    "8": "\u2088",
    "9": "\u2089"
  };
  return num.toString().split("").map((d) => map[d]).join("");
};
var humanScale = new import_human_format.default.Scale({
  B: 1e9,
  M: 1e6,
  K: 1e3
});
function formatHuman(value, options) {
  const num = Number(value || 0);
  if (num < 1e3) return num.toString();
  return (0, import_human_format.default)(Number(value || "0"), {
    scale: humanScale,
    separator: "",
    ...options
  });
}

// src/explorer.ts
import {
  mainnet,
  optimism,
  arbitrum,
  base,
  polygon,
  bsc
} from "viem/chains";
function getExplorerTxUrl(chainId, txHash) {
  const explorer = getExplorerBaseUrl(chainId);
  if (!explorer) return "";
  return `${explorer}/tx/${txHash}`;
}
function getExplorerAddressUrl(chainId, address) {
  const explorer = getExplorerBaseUrl(chainId);
  if (!explorer) return "";
  return `${explorer}/address/${address}`;
}
function getExplorerTokenUrl(chainId, tokenAddress) {
  const explorer = getExplorerBaseUrl(chainId);
  if (!explorer) return "";
  return `${explorer}/token/${tokenAddress}`;
}
function getExplorerBaseUrl(chainId) {
  switch (chainId) {
    case mainnet.id:
      return mainnet.blockExplorers.default.url;
    case optimism.id:
      return optimism.blockExplorers.default.url;
    case arbitrum.id:
      return arbitrum.blockExplorers.default.url;
    case base.id:
      return base.blockExplorers.default.url;
    case polygon.id:
      return polygon.blockExplorers.default.url;
    case hyperevm.id:
      return hyperevm.blockExplorers.default.url;
    case bsc.id:
      return bsc.blockExplorers.default.url;
    default:
      return void 0;
  }
}

// src/copy.ts
var copyToClipboard = (text, cb) => {
  if (navigator.clipboard && navigator.permissions) {
    navigator.clipboard.writeText(text).then(cb);
  } else if (document.queryCommandSupported("copy")) {
    const ele = document.createElement("textarea");
    ele.value = text;
    document.body.appendChild(ele);
    ele.select();
    document.execCommand("copy");
    document.body.removeChild(ele);
    cb?.();
  }
};

// src/geckoterminal.ts
var GeckoTerminal = class {
  constructor(apiKey) {
    this.apiKey = apiKey;
  }
  parsePairName(name) {
    const match = name.match(/^(.+?) \/ (.+?)(?: (\d+(\.\d+)?%)?)?$/);
    if (!match)
      return {
        symbol0: "",
        symbol1: "",
        feeTier: ""
      };
    const [, symbol0, symbol1, feeTier] = match;
    return {
      symbol0,
      symbol1,
      feeTier
      // e.g. "0.01%"
    };
  }
  async request(endpoint, params) {
    const url = new URL(`https://api.geckoterminal.com/${endpoint}`);
    Object.entries(params || {}).forEach(
      ([key, val]) => url.searchParams.append(key, String(val))
    );
    const res = await fetch(url, {
      headers: new Headers({
        "Content-Type": "application/json",
        ...this.apiKey ? { Authorization: `Bearer ${this.apiKey}` } : {}
      })
    });
    if (!res.ok) {
      console.error(res);
      throw new Error(
        `GeckoTerminal fetching error: ${endpoint}: ${res.statusText}`
      );
    }
    return res.json();
  }
  async getAllPairs(dex, options) {
    let page = 1;
    let allPairs = [];
    let currentPagePairs;
    do {
      currentPagePairs = await this.getPairs(dex, page, options);
      allPairs = allPairs.concat(currentPagePairs);
      page++;
      if (!this.apiKey) {
        if (page === 11) {
          break;
        }
      }
    } while (currentPagePairs.length > 0);
    return allPairs;
  }
  async getPairs(dex, page = 1, options) {
    const res = await this.request(
      `api/v2/networks/hyperevm/dexes/${dex}/pools`,
      {
        page,
        sort: "h24_volume_usd_desc",
        ...options
      }
    );
    return res.data.map((d) => {
      const { symbol0, symbol1, feeTier } = this.parsePairName(
        d.attributes.name
      );
      return {
        address: d.attributes.address,
        token0: d.relationships.base_token.data.id.split("_")[1] || "",
        token1: d.relationships.quote_token.data.id.split("_")[1] || "",
        symbol0: symbol0 || "",
        symbol1: symbol1 || "",
        token0Price: d.attributes.base_token_price_usd,
        token1Price: d.attributes.quote_token_price_usd,
        volume: {
          m5: d.attributes.volume_usd.m5,
          h1: d.attributes.volume_usd.h1,
          h6: d.attributes.volume_usd.h6,
          h24: d.attributes.volume_usd.h24
        },
        tvl: d.attributes.reserve_in_usd,
        dex,
        feeTier: feeTier ? parseFloat(feeTier) * 1e4 : 0,
        createdAt: new Date(d.attributes.pool_created_at).getTime()
      };
    });
  }
};

// src/dexscreener.ts
var DexScreener = class {
  constructor(apiKey) {
    this.apiKey = apiKey;
  }
  async request(endpoint, params) {
    const url = new URL(`https://api.dexscreener.com/${endpoint}`);
    Object.entries(params || {}).forEach(
      ([key, val]) => url.searchParams.append(key, String(val))
    );
    const res = await fetch(url, {
      headers: new Headers({
        "Content-Type": "application/json",
        ...this.apiKey ? { Authorization: `Bearer ${this.apiKey}` } : {}
      })
    });
    if (!res.ok) {
      throw new Error(
        `DexScreener fetching error: ${endpoint}: ${res.statusText}`
      );
    }
    return res.json();
  }
  async pairSearch(query) {
    return this.request("latest/dex/search", { q: query });
  }
};
export {
  DexScreener,
  GeckoTerminal,
  copyToClipboard,
  ellipseAddress,
  formatHuman,
  formatPrice,
  formatPriceSubscript,
  getExplorerAddressUrl,
  getExplorerTokenUrl,
  getExplorerTxUrl,
  humanScale,
  hyperevm
};
